<template>
  <WorkBasicDialog
    v-bind="$props"
    ref="dialog"
    :content-class="`w-icon-dialog ${contentClass}`"
  >
    <template #default="{ triggerResolve, triggerReject, close }">
      <slot
        :trigger-resolve="triggerResolve"
        :trigger-reject="triggerReject"
        :close="close"
      />
    </template>

    <template #header>
      <slot name="header" />
    </template>

    <template #header-append>
      <slot name="header-append" />
    </template>

    <template #content-wrapper>
      <div class="dialog-content-with-icon-wrapper">
        <WorkIcon
          :color="color"
        >
          {{ iconCode }}
        </WorkIcon>
        <label
          v-if="hasHtml"
          class="dialog-content-with-icon-content"
          v-html="message"
        />
        <span
          v-else
          class="dialog-content-with-icon-content"
        >
          {{ message }}
        </span>
      </div>
      <div
        :class="description ? 'dialog-content-append' : ''"
        v-html="description"
      />
    </template>

    <template #content-append>
      <slot name="content-append" />
    </template>

    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <slot
        name="dialog-actions"
        :trigger-resolve="triggerResolve"
        :trigger-reject="triggerReject"
        :close="close"
      >
        <template #abort-action>
          <slot
            name="abort-action"
            :trigger-resolve="triggerResolve"
            :trigger-reject="triggerReject"
            :close="close"
          >
            <template #abort-action-text>
              <slot name="abort-action-text" />
            </template>
          </slot>
        </template>

        <template #accept-action>
          <slot
            name="accept-action"
            :trigger-resolve="triggerResolve"
            :trigger-reject="triggerReject"
            :close="close"
            :accept-action-text="acceptActionText"
          >
            <template #accept-action-text>
              <slot name="accept-action-text" />
            </template>
          </slot>
        </template>
      </slot>
    </template>
  </WorkBasicDialog>
</template>

<script>
import WorkBasicDialog from "../WorkBasicDialog";
import WorkIcon from '@/components/global_components/icon/WorkIcon';
import { ref } from 'vue';
import i18n from "@/language/i18n";

export default {
  name: "WorkBasicIconDialog",
  components: {
    WorkBasicDialog,
    WorkIcon
  },
  props: {
    ...WorkBasicDialog.props,
    iconCode: { type: String, required: true },
    iconLabel: { type: String, required: true },
    color: { type: String, default: 'primary' },
    message: { type: String, required: true },
    description: { type: String },
    hasHtml: { type: Boolean, default: false },
    acceptActionText: { type: String, default: i18n.t('Dialogs.BasicDialog.accept') },
  },
  setup() {
    const dialog = ref(null);

    function open() {
      return dialog.value.open();
    }

    return { open, dialog }
  }
}
</script>

<style lang='scss'>
$icon-size: 3.75rem;
$icon-size-mobile: 1.875rem;

.w-icon-dialog {
  width: auto;

  .w-dialog-card {

    .dialog-content-append {
      margin-top: 1rem;
    }
    
    .dialog-content-with-icon-wrapper {
      display: flex;
      align-items: center;

      .dialog-content-with-icon-icon {
        margin-left: -0.313rem;
        font-size: 4.5rem;

        &.primary-color {
          color: $icon-color;
        }

        &.warning-color {
          color: var(--v-warning_orange-base);
        }

        &.error-color {
          color: var(--v-error-base);
        }
      }

      .dialog-content-with-icon-content {
        padding-left: 1rem;
      }
    }
  }

  .w-dialog-actions {
    box-shadow: none !important;
    padding-top: 0 !important;
  }

  .dialog-content-with-icon-wrapper .v-icon,
  .dialog-content-with-icon-wrapper .v-icon svg {
    height: $icon-size !important;
    width: $icon-size !important;

    @media #{map-get($display-breakpoints, 'xs-only')} {
      height: $icon-size-mobile !important;
      width: $icon-size-mobile !important;
    }
  }

  .dialog-content-with-icon-wrapper .dialog-content-with-icon-content {
    white-space: pre-wrap;
  }
}
</style>
